import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgRedux,
  DevToolsExtension,
  NgReduxModule,
} from "@angular-redux/store";
import { createLogger } from "redux-logger";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";

import { rootReducer } from "./core.reducer";
import { CoreActionService } from "./core.action";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { IAppState, INITIAL_STATE } from "./app.state";
import { ApiService } from "../services/api.service";
import { PoiActionService } from "./poi/poi.action";
import { ItinActionService } from "./itinerari/itinerari.action";
import { UserActionService } from "./users/users.action";
import { ThemesActionService } from "./themes/themes.action";
import { GeoPosActionService } from "./geographicalpos/geographicalpos.action";
import { LoggedActionService } from "./logged/logged.action";
import { environment } from "../../environments/environment";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["logged"],
  blacklist: [],
};

@NgModule({
  imports: [CommonModule, HttpClientModule, RouterModule, NgReduxModule],
  declarations: [],
  exports: [],
  providers: [
    CoreActionService,
    PoiActionService,
    ItinActionService,
    UserActionService,
    LoggedActionService,
    ThemesActionService,
    GeoPosActionService,
    ApiService,
  ],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    public store: NgRedux<IAppState>,
    devTools: DevToolsExtension
  ) {
    if (parentModule) {
      throw new Error(
        "CoreModule is already loaded. Import it in the AppModule only"
      );
    }

    let middlewares = [];
    if (!environment.production) {
      middlewares = [createLogger()];
    }
    const persistedReducer = persistReducer(persistConfig, rootReducer);

    store.configureStore(
      persistedReducer,
      INITIAL_STATE,
      middlewares,
      devTools.isEnabled() ? [devTools.enhancer()] : []
    );
    persistStore(store);
  }
}
